<template>
  <div class="form-list flex-box">
    <span v-if="!isAdministrator && student.is_archive" class="danger-color">该学员账号状态异常，学员信息需要核实并更新，请联系总部管理员</span>
    <template v-else>
      <div class="profile-box">
        <div class="container-item profile primary-background">
          <v-avatar :value="student.selfie" :size="130"/>
          <div class="nickname-box">
            <div class="profile-info">
              姓名：<span class="nickname">{{student.student_name}}</span><span v-if="student.is_del" class="danger-color">（该账号已被注销）</span>
            </div>
            <div class="profile-info">
              昵称：<span class="nickname">{{student.nickname}}</span>
            </div>
            <div class="profile-info">
              卡号：<span class="nickname">{{student.card_number}}</span>
            </div>
            <div>
              手机号：<span class="nickname">{{student.phone}}</span>
            </div>
            <div>
              积分：<span class="nickname">{{student.integral | toYuan}}</span>
            </div>
          </div>
        </div>

        <div class="container-item primary-background">
          <v-page-card-list :student-id="id" :used-card-id="student.used_card_id"/>
        </div>
      </div>

      <div class="container-item record-list-box primary-background">
        <el-tabs>
          <el-tab-pane label="预约记录">
            <v-page-course-reservation-record
              :student-id="id"
              :student-name="student.student_name"
              :start-date="reservationQuery.start_date"
              :end-date="reservationQuery.end_date"
              :reserve-state="reservationQuery.reserve_state"
            />
          </el-tab-pane>

          <el-tab-pane label="办卡记录">
            <v-page-card-add-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="办券记录">
            <v-page-card-ticket-add-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="代金券记录">
            <v-page-voucher-add-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="课卡修改">
            <v-page-card-update-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="个人资料">
            <v-page-student-update-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="积分变动">
            <v-page-integral-update-record :student-id="id"/>
          </el-tab-pane>

          <el-tab-pane label="访问记录">
            <v-page-student-view-record :student-id="id"/>
          </el-tab-pane>
        </el-tabs>
      </div>
    </template>

  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/student';

export default {
  name: RouteConfig.studentDetail.name,
  data: () => ({
    student: {
      is_del: 0,
      is_archive: 0,
      student_name: '',
      nickname: '',
      phone: '',
      selfie: '',
      card_number: '',
      used_card_id: 0,
      integral: 0,
    },
    reservationQuery: {
      start_date: '',
      end_date: '',
      reserve_state: '',
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
    isAdministrator() {
      return this.$store.getters.isAdministrator;
    }
  },
  beforeMount() {
    const { query } = this.$route;
    this.reservationQuery.start_date = query.start_date || '';
    this.reservationQuery.end_date = query.end_date || '';
    this.reservationQuery.reserve_state = query.reserve_state || '';
    this.show();
  },
  methods: {
    async show() {
      if (!this.id) return;
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { student } = this;
      Object.keys(data).forEach(key => {
        if (key in student) student[key] = data[key];
      });
    },
  },
};
</script>

<style src="./detail.css" scoped/>
<style src="./detail-phone.css" scoped/>
